import React from "react";
import Sidebar from "../../Components/Navbar/Sidebar";
import DashboardHeader from "../../Components/Navbar/DashboardHeader";
import { Outlet, useLocation } from "react-router-dom";

const DashboardLayout = () => {
  const location = useLocation();
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex flex-col w-full px-8 gap-5">
        <DashboardHeader />
        <Outlet key={location.key} />
      </div>
    </div>
  );
};

export default DashboardLayout;
